import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
